<template>
  <q-card class="clients-added-card">
    <q-toolbar class="text-primary">
      <q-toolbar-title>
        <router-link :to="`/admin/accounts/${accountId}/clients`" class="link text-primary">
          Clients Added
        </router-link>
      </q-toolbar-title>
      <q-icon name="fa fa-address-book" size="sm" />
    </q-toolbar>
    <q-separator />
    <q-card-section>
      <loader :task="task" />
      <div v-show="numClients !== null" class="row">
        <div class="col-6">
          <span class="text-h3 text-bold">{{  numClients }}</span>
          Client<span v-show="numClients !== 1">s</span>
        </div>
        <div class="col-6 text-right" style="align-self: flex-end">
          <add-client-btn
            :account-id="accountId"
            label="Add"
            flat
            rounded
            @added="numClients++"
          />
        </div>
      </div>
    </q-card-section>
  </q-card>
</template>

<style lang="scss">
@import '../../styles/quasar.variables';

.clients-added-card {
  border-bottom: 3px solid $primary;
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import Loader from '@/components/loading/AsyncLinearProgress.vue';
import repository from '../../client/client-repository';
import AddClientBtn from '../../client/create/AddClientBtn.vue';

interface Data {
  task: Promise<number>|null,
  numClients: number|null,
}

export default defineComponent({
  components: { Loader, AddClientBtn },
  props: {
    accountId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
      numClients: null,
    };
  },
  watch: {
    accountId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
  },
  methods: {
    load() {
      this.task = repository.count(this.accountId);
      this.task.then((numClients) => {
        this.numClients = numClients;
      });
    },
  },
});
</script>
